// client/src/modules/new-year-tree/TreeBootScreen.tsx
import { BootScreen } from '../../shared/coloring-kit/status/BootScreen';

import { treeProduct } from './product';

/** Заставка ёлки: общий `BootScreen` кита со знаком и названием продукта. */
export function TreeBootScreen({ text = 'Наряжаем ёлку…', hidden = false }: { text?: string; hidden?: boolean }) {
  return <BootScreen brand={treeProduct.brand} text={text} hidden={hidden} theme="winter" />;
}
